import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import useRouteParam from '../../hooks/useRouteParam'
import BreakPoints from '../../styles/breakPoints'
import LogoSvg from '../atoms/logoSvg'
import DownloadBtnArea from '../molecules/downloadBtnArea'

const Wrapper = styled.footer`
  width: 100%;
  background: #1e3041;
  text-align: center;
  position: relative;

  .p-foot-inner {
    max-width: 1366px;
    margin: 0 auto;
    padding: 40px 10px 20px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .p-nav-area {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-bottom: 50px;

      a {
        color: #ffffff;
        display: block;
        font-weight: 600;
        margin: 0 60px 0 0;
        text-decoration: none;
        position: relative;

        &:hover {
          text-decoration: none;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      &.sub {
        a {
          font-size: 0.875em;
          color: #78828d;
          font-weight: 400;
          margin: 0 40px 0 0;
        }
      }
      &.top {
        margin-bottom: 15px;
      }
    }

    .p-logo-copy {
      width: 100%;
      margin: 0 0 -5px;
      color: #ffffff;
      font-size: 0.875em;
      text-align: center;
    }

    .p-logo-link {
      height: 64px;
      width: 200px;
      display: flex;
      align-items: center;
      margin: 0 auto 20px;

      .logo {
        margin: 0 5px 0 0;
        padding: 0;
        width: 200px;

        svg {
          .logo-txt {
            fill: #ffffff;
          }
        }
      }
    }

    .p-copyright {
      width: 100%;
      font-size: 0.875em;
      color: #78828d;
    }
  }

  ${BreakPoints.xLarge} {
    .p-foot-inner {
      .p-nav-area {
        display: block;
        text-align: center;

        a {
          display: inline-block;
          margin: 0;
          padding: 0 15px 10px;
        }

        &.sub {
          a {
            margin: 0;
          }
        }
      }
    }
  }

  ${BreakPoints.medium} {
  }
`

/**
 * コラムサイトフッター
 * @constructor
 */
const Columnfooter = () => {
  const routeParam1 = useRouteParam('https://www.kintaicloud.jp/feature/')
  const routeParam2 = useRouteParam('https://www.kintaicloud.jp/benefit/')
  const routeParam3 = useRouteParam('https://www.kintaicloud.jp/function/')
  const routeParam4 = useRouteParam('https://www.kintaicloud.jp/plan-list/')
  const routeParam5 = useRouteParam('https://www.kintaicloud.jp/service-faq/')
  const routeParam6 = useRouteParam('https://www.kintaicloud.jp/gallery/')
  const routeParam7 = useRouteParam('https://www.kintaicloud.jp/download/')
  const routeParam8 = useRouteParam('https://www.kintaicloud.jp/help/')
  const routeParam9 = useRouteParam('https://sign-up.kintaicloud.jp/sign-up')
  const routeParam10 = useRouteParam('https://app.kintaicloud.jp')
  const routeParam11 = useRouteParam('https://www.kintaicloud.jp/terms/')
  const routeParam12 = useRouteParam('https://www.kintaicloud.jp/policy/')
  const routeParam13 = useRouteParam(
    'https://www.kintaicloud.jp/externaltools/'
  )
  const routeParam14 = useRouteParam('https://www.kintaicloud.jp/law/')
  const routeParam15 = useRouteParam('https://www.kintaicloud.jp/contact/')

  return (
    <Wrapper>
      <div className="p-foot-inner">
        <div className="p-nav-area mb-040">
          <a href={routeParam1} target="_blank" rel="noreferrer">
            特徴
          </a>
          <a href={routeParam2} target="_blank" rel="noreferrer">
            導入効果
          </a>
          <a href={routeParam3} target="_blank" rel="noreferrer">
            機能
          </a>
          <a href={routeParam4} target="_blank" rel="noreferrer">
            料金
          </a>
          <a href={routeParam5} target="_blank" rel="noreferrer">
            よくあるご質問
          </a>
          <a href={routeParam6} target="_blank" rel="noreferrer">
            ギャラリー
          </a>
          <a href={routeParam7} target="_blank" rel="noreferrer">
            資料ダウンロード
          </a>
          <a href={routeParam8} target="_blank" rel="noreferrer">
            ヘルプ
          </a>
        </div>
        <div className="p-nav-area">
          <a href={routeParam9} target="_blank" rel="noreferrer">
            アカウント作成
          </a>
          <a href={routeParam10} target="_blank" rel="noreferrer">
            ログイン
          </a>
        </div>
        <p className="p-logo-copy anim-fade-up delay-2">
          ＼ すべての企業に、勤怠クラウドを ／
        </p>
        <Link to={useRouteParam('/')} className="p-logo-link anim-fade-up">
          <LogoSvg />
        </Link>
        <DownloadBtnArea />
        <div className="p-nav-area sub top">
          <a href={routeParam11} target="_blank" rel="noreferrer">
            利用規約
          </a>
          <a href={routeParam12} target="_blank" rel="noreferrer">
            プライバシーポリシー
          </a>
          <a href={routeParam13} target="_blank" rel="noreferrer">
            外部送信規律に関する公表事項
          </a>
          <a href={routeParam14} target="_blank" rel="noreferrer">
            特定商取引法に基づく表記
          </a>
          <a href={routeParam15} target="_blank" rel="noreferrer">
            お問い合わせ
          </a>
          <a href="https://clinks.jp/" target="_blank" rel="noreferrer">
            運営会社
          </a>
        </div>
        <div className="p-nav-area sub">
          {/* eslint-disable react/jsx-no-target-blank -- rel="noopener"のみ（referrer送信用） */}
          <a
            href="https://www.knowleful.ai/?utm_source=kintaicloud&utm_medium=referral&utm_campaign=site"
            target="_blank"
            rel="noopener"
          >
            法人向けChatGPT・生成AIのナレフルチャット
          </a>
          <a
            href="https://www.knowleful.ai/plus/?utm_source=kintaicloud&utm_medium=referral&utm_campaign=column"
            target="_blank"
            rel="noopener"
          >
            生成AIコラム
          </a>
          <a
            href="https://help.knowleful.jp/hc/ja?utm_source=kintaicloud&utm_medium=referral&utm_campaign=help"
            target="_blank"
            rel="noopener"
          >
            ナレフルチャットヘルプセンター
          </a>
          {/* eslint-enable react/jsx-no-target-blank */}
        </div>
        <p className="p-copyright">
          &copy;2021 CLINKS Co., Ltd. All Rights Reserved.
        </p>
      </div>
    </Wrapper>
  )
}

export default Columnfooter
